<template>
  <div class="enrolment-closed-page px-4 py-4 md:px-5">
    <div class="mx-auto space-y-5">
      <section class="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm">
        <div class="flex flex-col gap-4">
          <div>
            <p class="text-[15px] font-semibold text-slate-900">수강신청 마감 현황</p>
            <p class="mt-1 text-sm text-slate-500">선택한 그룹/시간대의 마감 현황과 수동 마감 여부를 확인합니다.</p>
          </div>

          <div class="grid gap-4 md:grid-cols-3">
            <div class="info-card md:col-span-1">
              <span class="info-label">Company / 과정</span>
              <p class="info-value">[{{ listPage.getCompanyName() }} {{ listPage.getSugangName() }}]</p>
            </div>
            <div class="info-card md:col-span-1">
              <span class="info-label">유형 / 언어 / 레벨</span>
              <p class="info-value">
                {{ listPage.getSubType() }} {{ listPage.getGroupType() }} {{ listPage.getLessonTime() }} {{ listPage.getLanguage() }} {{ listPage.getLevel() }}
              </p>
            </div>
            <div class="info-card md:col-span-1">
              <span class="info-label">클래스 / 시간</span>
              <p class="info-value">
                {{ listPage.getClassName() }} {{ listPage.getClassTimeInfo() }} {{ listPage.getClassWeekTime() }}
              </p>
            </div>
          </div>
        </div>
      </section>

      <section class="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm">
        <div class="mb-4 flex flex-col gap-3 border-b border-slate-200 pb-4 md:flex-row md:items-center md:justify-between">
          <div>
            <p class="text-base font-semibold text-slate-900">마감 그룹 목록</p>
            <p class="mt-1 text-sm text-slate-500">총 {{ listPage.enrolmentGroupList.length }}건</p>
          </div>
          <div class="flex flex-wrap gap-2 text-sm text-slate-500">
            <span class="result-chip">페이지 {{ listPage.searchParams.pageNum }}</span>
            <span class="result-chip">페이지당 {{ listPage.searchParams.pageSize }}건</span>
          </div>
        </div>

        <div class="table-scroll-wrap rounded-xl border border-slate-200">
          <BagicTable
            :header="listPage.tableHeader"
            :list="listPage.enrolmentGroupList"
            :pageSize="listPage.searchParams.pageSize"
            :totalRows="listPage.totalCnt"
            :enableCheckBox="false"
            :checkParamName="[]"
            @paging-click="listPage.movePage"
            :detailRowName="listPage.detailRowName"
            :detailParamName="listPage.detailParamName"
            @check-click="listPage.checkBoxClick"
          >
          </BagicTable>
        </div>
      </section>
    </div>
  </div>
</template>
<script>
import { onMounted, reactive, computed } from "vue";
import { useRoute } from "vue-router";
import axios from "@/plugins/axios.js";
import BagicTable from "@/components/BagicTable.vue";
export default {
  components: {
    BagicTable,
  },
  setup() {
    const route = useRoute();

    const { idxLeSugang, idxLeSugangGroupClass, idxLeSugangGroupLevel, className, startTime, subType, groupType, lessonTime, language, level, timeInfo, weekTime } = route.query

    const listPage = reactive({
      // 회사 정보
      siteMainInfo: {
        kname: "", // 회사명
      },

      // 수강 정보
      sugangInfo: {
        sugangName: "", // 과정명
      },

      idxLeSugang: idxLeSugang,
      idxLeSugangGroupLevel: idxLeSugangGroupLevel,
      idxLeSugangGroupClass: idxLeSugangGroupClass,

      startTime: startTime,

      subType: subType,
      groupType: groupType,
      lessonTime: lessonTime,
      language: language,
      level: level,

      className: className,
      classTimeInfo: timeInfo,
      classWeekTime: weekTime,
      
      classWeekTimeNum: weekTime ? weekTime.replace(/[^0-9]/g, "") : "",
      
      // 회사명
      getCompanyName () {
        const { kname } = this.siteMainInfo
        return kname
      },
      
      // 과정명
      getSugangName() {
        const { sugangName } = this.sugangInfo
        return sugangName
      },

      // 일반/지원 유형
      getSubType() {
        if (!this.subType) return ""
        return `[${this.subType}]`
      },

      // 그룹 유형
      getGroupType() {
        if (!this.groupType) return ""
        return `[${this.groupType}]`
      },

      // 시간 유형
      getLessonTime() {
        if (!this.lessonTime) return ""
        return `[${this.lessonTime}]`
      },

      // 언어 유형
      getLanguage() {
        if (!this.language) return ""
        return `[${this.language}]`
      },

      // 레벨 유형
      getLevel() {
        if (!this.level) return ""
        return `[${this.level}]`
      },

      // 과정명
      getClassName() {
        if (!this.className) return ""
        return `[${this.className}]`
      },

      // 과정 시간대
      getClassTimeInfo() {
        if (!this.classTimeInfo) return ""
        return `[${this.classTimeInfo}]`
      },

      // 과정 시간대 > 주차 정보
      getClassWeekTime() {
        if (!this.classWeekTime) return ""
        return `[${this.classWeekTime}]`
      },

      searchParams: {
        pageNum: 1,
        pageSize: 1000,
      },
      tableHeader: {
        rowNum: "No",
        groupName: "그룹명",
        courseName: "B2B 과정명",
        tutorName: "Tutor",
        companyName: "Company",
        bookName: "교재명",
        timeInfo: "수업시간",
        lessonTime: "분수",
        lecDay: "요일",
        cntLectureUser: "학습자수",
        sdate: "Start Date",
        edate: "End Date",
        hqName: "HQ매니저",
        btnToggleEnrollmentClosed: "마감유무"
      },

      detailParamName: "idxColumnName",
      totalCnt: 0,
      enrolmentGroupList: [],

      // 수강 메타 정보 조회
      getSugangData() {
        if (idxLeSugang && idxLeSugang !== "0") {
          const params = {
            idxLeSugang: idxLeSugang,
          };
          axios.get("/admin/sugang", { params }).then(function (res) {
            if (res.data.success) {
              listPage.siteMainInfo = res.data.data.siteMainInfo
              listPage.sugangInfo = res.data.data.sugangInfo
            } else {
              // 처리 실패 로직
            }
          });
        }
      },

      // 리스트 조회 및 검색
      getEnrolementGroupList() {
        // 요청 파라미터 없는 경우 잘못된 접근으로 판단
        if (!this.idxLeSugangGroupLevel) return
        if (!this.idxLeSugangGroupClass) return
        if (!this.startTime) return
        if (!this.classWeekTimeNum) return

        axios
          .get("/admin/sugangGroupDashBoard", {
            params: {
              idxLeSugangGroupLevel: this.idxLeSugangGroupLevel,
              idxLeSugangGroupClass: this.idxLeSugangGroupClass,
              startTime: encodeURIComponent(this.startTime),
              weekNum: this.classWeekTimeNum
            }
          })
          .then(function (res) {
            const { success, data } = res.data
            if (!success) {
              // 요청 실패
              return
            }

            // 요청 성공 이 후 목록 화면 구성 진행
            const enrolmentGroupList = listPage.makeEnrolmentGroupList(data)
            
            // 데이터셋 매핑
            listPage.enrolmentGroupList = enrolmentGroupList
          });    
      },

      // 테이블 구성하기 위한 데이터셋 반환
      makeEnrolmentGroupList(list) {
        const enrolmentGroupList = []
        if (!list || !list.length) return []

        list.forEach((data, index) => {
          const { idxLeSugangGroupClassRoom, groupName, courseName, tutorName, companyName, bookName, stime, etime, weekNum, lecMin, lecDay, cntLectureUser, sdate, edate, hqName, isEnrollmentClosedManual, isEnrollmentClosedAuto } = data

          const enrolmentGroupInfo = {
            rowNum: index + 1, // No
            idxColumnName: idxLeSugangGroupClassRoom,
            idxLeSugangGroupClassRoom: idxLeSugangGroupClassRoom,
            groupName: `<span class="text-sky-600">${groupName}</span>`,
            courseName: courseName,
            tutorName: tutorName,
            companyName: companyName,
            bookName: bookName,
            timeInfo: `${stime} ~ ${etime}`,
            lessonTime: `주${weekNum}회/${lecMin}분`,
            lecDay: lecDay,
            cntLectureUser: cntLectureUser,
            sdate: sdate,
            edate: edate,
            hqName: hqName,
            btnToggleEnrollmentClosed: listPage.makeBtnToggleClosed(idxLeSugangGroupClassRoom, isEnrollmentClosedManual, isEnrollmentClosedAuto)
          }

          enrolmentGroupList.push(enrolmentGroupInfo)
        })

        return enrolmentGroupList
      },

      // 수동마감여부, 자동마감여부 값에 따라 마감유무 버튼 구성
      makeBtnToggleClosed(idxLeSugangGroupClassRoom, isEnrollmentClosedManual, isEnrollmentClosedAuto) {
        // 마감유무 토글버튼 설정
        const btnToggleClosed = {
          // 체크 여부는 수동 마감 상태에 따라 설정
          checked: listPage.isChecked(isEnrollmentClosedManual),
          // 비활성화여부는 자동 마감 값을 기준으로 설정
          disabled: listPage.isChecked(isEnrollmentClosedAuto),
          clickEvent: (btnToggle) => {
            // 수강 신청 마감 수동 처리 프로세스
            let confirmMessage = "해당 그룹의 수강신청을 마감하시겠습니까?"
            if (!btnToggle.checked) {
              confirmMessage = "해당 그룹의 수강신청 마감을 해제하시겠습니까?"
            }

            if (!confirm(confirmMessage)) {
              btnToggle.checked = !btnToggle.checked
              return
            }

            // API 상태 변경 API 호출
            listPage.updateEnrolmentGroupStatus(idxLeSugangGroupClassRoom, btnToggle)
          }
        }
        return btnToggleClosed
      },

      // YN 필드 값을 기준으로 Boolean 응답 반환
      isChecked(dataYn) {
        return dataYn === 'Y'
      },

      // 그룹 수강신청 마감 활성화/비활성화 처리
      updateEnrolmentGroupStatus(idxLeSugangGroupClassRoom, btnToggle) {
        const params = {
          idxLeSugangGroupClassRoom: idxLeSugangGroupClassRoom
        }
        axios
          .post("/admin/sugangGroupEnrollmentStatus", params)
          .then(function (res) {
            if (!res) {
              // 서버 요청 실패
              btnToggle.checked = !btnToggle.checked
              return
            }

            const { success, message, data } = res.data
            if (!success) {
              // API 요청 실패 메시지 얼럿
              alert(message);
              // 마감 유무 버튼 이전 상태로 원복
              btnToggle.checked = !btnToggle.checked
              return
            }

            // 마감유무 데이터 갱신
            const { isEnrollmentClosedManual, isEnrollmentClosedAuto } = data
            btnToggle.checked = listPage.isChecked(isEnrollmentClosedManual)
            btnToggle.disabled = listPage.isChecked(isEnrollmentClosedAuto)
          });
      }
    });

    onMounted(() => {
      listPage.getSugangData();
      listPage.getEnrolementGroupList();
    });

    return {
      listPage
    };
  },
};
</script>
<style scoped>
.enrolment-closed-page {
  min-height: 100%;
  background:
    radial-gradient(circle at top left, rgba(226, 232, 240, 0.65), transparent 32rem),
    linear-gradient(180deg, #f8fafc 0%, #ffffff 42%);
}

.info-card {
  border: 1px solid #e2e8f0;
  border-radius: 1rem;
  background: #f8fafc;
  padding: 1rem;
}

.info-label {
  font-size: 0.75rem;
  font-weight: 700;
  color: #64748b;
}

.info-value {
  margin-top: 0.5rem;
  word-break: break-word;
  font-size: 1rem;
  font-weight: 700;
  color: #0f172a;
  line-height: 1.5;
}

.result-chip {
  display: inline-flex;
  align-items: center;
  border-radius: 9999px;
  border: 1px solid #e2e8f0;
  background: #f8fafc;
  padding: 0.4rem 0.8rem;
}

.table-scroll-wrap {
  max-height: calc(100vh - 260px);
  overflow: auto;
}

:deep(table) {
  margin-bottom: 0;
  table-layout: auto;
}

:deep(thead tr) {
  background: #f8fafc;
}

:deep(th) {
  border-color: #e2e8f0;
  padding: 0.85rem 0.65rem;
  font-size: 0.82rem;
  font-weight: 700;
  color: #334155;
  white-space: nowrap;
}

:deep(td) {
  border-color: #e2e8f0;
  padding: 0.85rem 0.65rem;
  font-size: 0.9rem;
  line-height: 1.5;
  color: #334155;
  background-color: #fff;
  white-space: nowrap;
}

:deep(tbody tr:nth-child(even) td) {
  background-color: #fbfdff;
}

:deep(tbody tr:hover td) {
  background-color: #f8fbff;
}

:deep(td p) {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 2rem;
}

:deep(td a),
:deep(td button) {
  white-space: nowrap;
}

:deep(td a) {
  color: #0369a1;
  font-weight: 700;
  text-decoration: none;
}

:deep(.bg-white.border-t.border-gray-200) {
  border-top: 1px solid #e2e8f0;
  background: #fff;
}

:deep(nav[aria-label="Pagination"]) {
  gap: 0.25rem;
}

:deep(nav[aria-label="Pagination"] > span),
:deep(nav[aria-label="Pagination"] .relative.inline-flex) {
  border-radius: 14px;
}

:deep(nav[aria-label="Pagination"] .z-10) {
  background: #1d4ed8;
  color: #fff;
}

:deep(.toggle-switch .toggle-label) {
  transition: background-color 0.3s;
}

:deep(.toggle-switch .toggle-label::before) {
  content: "";
  position: absolute;
  width: 15px;
  height: 14px;
  border-radius: 50%;
  top: 3px;
  left: 3px;
  background-color: #2563eb;
  transition: transform 0.3s;
}

:deep(.toggle-switch .toggle-label) {
  border: 3px solid #2563eb;
  background-color: white;
}

:deep(.toggle-switch .toggle-input:checked + .toggle-label) {
  background-color: #2563eb;
}

:deep(.toggle-switch .toggle-input:checked + .toggle-label::before) {
  transform: translateX(20px);
  background-color: #fff;
}

:deep(.toggle-switch .toggle-label.disabled) {
  background-color: lightgray !important;
  border-color: lightgray;
  pointer-events: none;
  cursor: none;
}

:deep(.toggle-switch .toggle-label.disabled::before) {
  background-color: #fff;
}

@media (max-width: 1024px) {
  :deep(table) {
    min-width: 1400px;
  }
}
</style>
